import { render, staticRenderFns } from "./Fa2Form.vue?vue&type=template&id=174f08b5"
import script from "./Fa2Form.vue?vue&type=script&lang=js"
export * from "./Fa2Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports